module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/design-tile-images/design-tile-04-665c09953a21b9b99b25e0b435a1d90b.jpg";